import React, { useEffect, useState } from 'react';

export const Delayed: React.FunctionComponent<
	React.PropsWithChildren<{
		children: React.ReactNode;
		milliseconds?: number;
	}>
> = ({ children, milliseconds = 1 }) => {
	const [show, setShow] = useState(false);
	useEffect(() => {
		const timeoutId = setTimeout(() => setShow(true), milliseconds);
		return () => clearTimeout(timeoutId);
	}, []);

	return <>{show ? children : null}</>;
};
